module.exports = __webpack_public_path__ + "img/group-icon.9ea8ca81.svg";